webpackJsonp([145532727447631],{

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _tom = __webpack_require__(137);
	
	var _tom2 = _interopRequireDefault(_tom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Profile = function Profile() {
	  return _react2.default.createElement('img', { className: 'img-fluid rounded-circle', src: _tom2.default });
	};
	
	exports.default = Profile;
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tom.8773dd12.jpg";

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(13);
	
	var _profile = __webpack_require__(76);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var reference = data.markdownRemark;
	  var next = pathContext.next,
	      prev = pathContext.prev;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: '' + reference.frontmatter.title,
	      meta: [{ name: 'description', content: reference.frontmatter.excerpt || reference.excerpt }, { name: 'keywords', content: reference.frontmatter.technologies }]
	    }),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'bg evelope' },
	        _react2.default.createElement(
	          _reactstrap.Container,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'align-items-center py-5' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                reference.frontmatter.title
	              ),
	              _react2.default.createElement(
	                'h4',
	                { className: 'text-muted' },
	                'Referenzen und Use-Cases.'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'text-center text-md-left py-4 py-md-6', sm: '2' },
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '3', sm: '12' },
	                _react2.default.createElement(_profile2.default, null)
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '9', sm: '12' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'small mt-4' },
	                  'geschrieben von ',
	                  reference.frontmatter.author,
	                  ' am ',
	                  _react2.default.createElement(
	                    'time',
	                    { dateTime: reference.frontmatter.date },
	                    reference.frontmatter.formattedDate
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'py-4 py-md-6 reference-text', sm: { size: 8, offset: 1 } },
	            _react2.default.createElement('div', { className: 'text-justify', dangerouslySetInnerHTML: { __html: reference.html } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'd-block small mt-5 py-5 border-top' },
	              _react2.default.createElement(
	                'span',
	                { className: 'text-uppercase' },
	                reference.frontmatter.company
	              ),
	              ' \u2014 ',
	              _react2.default.createElement(
	                'span',
	                { className: 'text-muted' },
	                reference.frontmatter.technologies.join(', ')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'navigation' },
	              prev && _react2.default.createElement(
	                Link,
	                { className: 'link prev', to: prev.frontmatter.path },
	                prev.frontmatter.title
	              ),
	              next && _react2.default.createElement(
	                Link,
	                { className: 'link next', to: next.frontmatter.path },
	                next.frontmatter.title
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-reference-js-cfc9ba7b76f27268fd2c.js